<script>
// TODO FE: This code needs some nullchecks, but currently the values from the API are incorrect.
// Import general mixin for shared functionality.
import mixin from './../mixin';

export default {
    mixins: [mixin],
    props: {
        imageSets: {
            type: Array,
            required: true,
        },
    },
    // Retrieve width and height from first image in set for refucing cumulative layout shift.
    // Ideally, these values come from the API in the future.
    computed: {
        lastImage() {
            return this.imageSets?.[0]?.images?.length ? this.imageSets[0].images[this.imageSets[0].images.length - 1] : null;
        },
        lastWidth() {
            return this.lastImage?.displayWidth || null;
        },
        lastHeight() {
            return this.lastImage?.displayHeight || null;
        },
    },
    methods: {
        // Simple media query transformer.
        toMediaQuery(mediaString) {
            if (!mediaString) return '';
            return mediaString.split('"')[1];
        },
    },
    
};
</script>

<template>
    <picture class="image is-clipped">
        <template v-for="(format, index) in reverse(imageSets[0].images)" 
                  :key="index">
            <source
                type="image/webp"
                :srcset="format.webPUrl"
                :sizes="format.displayWidth + 'px'"
                :media="toMediaQuery(format.mediaQuery)" />
        </template>
        <img
            :src="imageSets[0].images[0].defaultCropUrlJpeg"
            :alt="imageSets[0].imageAlt"
            :width="lastWidth"
            :height="lastHeight"
            onerror="this.onerror=null; this.style.backgroundColor='#cccccc'" />
    </picture>
</template>
